define('responsive-pitch-fx/lib/enums/config',['require','exports','module'],function(require,exports,module){
    var BASE_FOOT = 12,
        EYE_TO_SCREEN = 6,
        interpolatedPlateWidth = 105,
        interpolatedPlateFront = 105;

    return {
        className       : "responsive-pitch-fx",
        font            : "gd-primary-bold, Helvetica Neue Bold, HelveticaNeue-Bold, Helvetica, Arial",
        batterScaling   : true,
        hotColdZones    : true,
        fadeOldPitches  : false,
        smoothing       : true,
        domBalls        : false,
        hoverData       : true,
        type            : 'front',
        foot            : BASE_FOOT,
        eyeToScreen     : EYE_TO_SCREEN,
        canvasDensity   : (window.devicePixelRatio || 2.0).toFixed(2),

        interpolatedPlateWidth : interpolatedPlateWidth,
        interpolatedPlateFront : interpolatedPlateFront,
        base_width      : 1024,
        base_height     : 704,
        mode            : '3d',
        tiltShift       : false,
        oldTimey        : false,

        // Animation
        numberOfAnimationPoints: 1000 / 40,
        timing          : 1000 / 36,

        //use for 2D pitch, from ipad...
        x_center        : 0.5,
        y_center        : 0.7 * 0.5,

        offset_x        : 103,
        offset_y        : 124,

        batterHeight    : "6-1",
        batterScaling   : true,
        /*  Ratio of batter height/width to field height/width */
        batterX         : 211.968,
        batterY         : 430.0032,
        batterTop       : 182.0544,
        batterLR        : 279.5,
        // batterLR: 234.4959,
        // batterLeft : 554.496,
        strikeZone      : {
            szBot       : 1.7,
            szTop       : 5.6 / 10 * EYE_TO_SCREEN  // 3.8 at eye to screen 10
        },
        eyetoScreen     : EYE_TO_SCREEN
    };
});
